<script setup lang="ts">
import ForgotPasswordDialog from '../components/ForgotPasswordDialog.vue'
import LoginForm from '../components/LoginForm.vue'
import { PRODUCT_NAME, TAGLINE } from '../branding'
import { openDialog } from '../ui/dialogs'

function openForgot(email: string) {
  void openDialog(ForgotPasswordDialog, { initialEmail: email })
}
</script>

<template>
  <main class="landing">
    <div class="card">
      <header>
        <h1>{{ PRODUCT_NAME }}</h1>
        <p>{{ TAGLINE }}</p>
      </header>

      <LoginForm @forgot-password="openForgot" />
    </div>
  </main>
</template>

<style scoped>
.landing {
  display: grid;
  place-items: center;
  min-height: 100%;
  padding: 1.5rem;
  background: var(--bg-subtle);
}

.card {
  width: min(22rem, 100%);
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 1.75rem;
}

header {
  margin-bottom: 1.5rem;
  text-align: center;
}

h1 {
  margin: 0 0 0.35rem;
  font-size: 1.6rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}

header p {
  margin: 0;
  color: var(--fg-muted);
  font-size: 0.875rem;
  line-height: 1.45;
}
</style>
